import { render, staticRenderFns } from "./CustomPatternUpload.vue?vue&type=template&id=1b785d7c"
import script from "./CustomPatternUpload.vue?vue&type=script&lang=js"
export * from "./CustomPatternUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports